import React from 'react';
import { cn } from '@chapche/ui';
import { CheckIconThin } from '../appearence/icons/check_icon_thin';

const Checkbox = ({ checked, handleChecked }) => (
    <label className="checkbox__label relative inline-flex h-24 w-24 shrink-0 cursor-pointer items-center justify-center">
        <input
            type="checkbox"
            className={cn(
                'checkbox__input peer absolute inset-0 z-10 m-0 h-24 w-24 cursor-pointer appearance-none rounded-checkbox border-2 border-solid border-green-accent bg-white',
                checked && 'checkbox__input_checked bg-green-accent',
            )}
            checked={checked}
            onChange={(e) => {
                e.stopPropagation();
                handleChecked(e.target.checked);
            }}
        />
        <CheckIconThin
            nameOfClass={cn(
                'checkbox__icon pointer-events-none relative z-[11] h-16 w-16 fill-white',
                checked ? 'checkbox__icon_checked block' : 'hidden',
            )}
        />
    </label>
);

export default Checkbox;
